import { processListings } from '../../helpers';
import type { ListingState, SaleOrLease, SortOrder } from '../../types';
import { SET_SALE_OR_LEASE, SET_SEARCH_TEXT, SET_SORT_ORDER, UPDATE_LISTING_GUID } from '../actions';

const initialState: ListingState = {
  matchedListings: [],
  unmatchedAnywhereListings: [],
  unmatchedBuildoutListings: [],
  buildoutListings: [],
  anywhereListings: [],
  sort: { field: 'address', direction: 'asc' },
  searchText: '',
  saleOrLease: 'all'
};

export default function (state = initialState, action) {
  switch (action.type) {
  case UPDATE_LISTING_GUID: {
    const { guid, buildoutListingId } = action.payload;
    const listingState : ListingState = { ...state };
    const boListing = listingState.buildoutListings.find(listing => listing.id === buildoutListingId);
    if (boListing) {
      boListing.guid = guid;
      const {
        matchedListings, unmatchedAnywhereListings, unmatchedBuildoutListings
      } = processListings(
        listingState.anywhereListings,
        listingState.buildoutListings,
        listingState.sort,
        listingState.searchText,
        listingState.saleOrLease
      );
  
      return {
        ...listingState,
        matchedListings,
        unmatchedBuildoutListings,
        unmatchedAnywhereListings
      };
    }

    return state;
  }
  case SET_SORT_ORDER: {
    const { changes } : { changes: Partial<SortOrder> } = action.payload;
    const listingState: ListingState = { ...state, sort: { ...state.sort, ...changes } };

    const {
      matchedListings, unmatchedAnywhereListings, unmatchedBuildoutListings
    } = processListings(
      listingState.anywhereListings,
      listingState.buildoutListings,
      listingState.sort,
      listingState.searchText,
      listingState.saleOrLease
    );

    return {
      ...listingState,
      matchedListings,
      unmatchedAnywhereListings,
      unmatchedBuildoutListings
    };
  }
  case SET_SEARCH_TEXT: {
    const { searchText } : { searchText: string } = action.payload;
    const listingState: ListingState = { ...state, searchText };

    const {
      matchedListings, unmatchedAnywhereListings, unmatchedBuildoutListings
    } = processListings(
      listingState.anywhereListings,
      listingState.buildoutListings,
      listingState.sort,
      searchText,
      listingState.saleOrLease
    );

    return {
      ...listingState,
      matchedListings,
      unmatchedAnywhereListings,
      unmatchedBuildoutListings
    };
  }
  case SET_SALE_OR_LEASE: {
    const { saleOrLease } : { saleOrLease: SaleOrLease } = action.payload;
    const listingState: ListingState = { ...state, saleOrLease };

    const {
      matchedListings, unmatchedAnywhereListings, unmatchedBuildoutListings
    } = processListings(
      listingState.anywhereListings,
      listingState.buildoutListings,
      listingState.sort,
      listingState.searchText,
      saleOrLease
    );

    return {
      ...listingState,
      matchedListings,
      unmatchedAnywhereListings,
      unmatchedBuildoutListings
    };
  }
  default: {
    return state;
  }
  }
}
